import { PostHog, PostHogProvider, usePostHog } from 'posthog-js/react';
import { dispatchManagerFeatures } from '../featureFlags/dispatchManagerFeatures';
import posthog from 'posthog-js';

const { isPosthogOn } = dispatchManagerFeatures;

export const usePostHogHook: () => PostHog = isPosthogOn
    ? usePostHog
    : () => ({} as PostHog);

if (
    typeof window !== 'undefined' &&
    isPosthogOn &&
    // posthog is being initialized multiple times, we need to track the package
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    !(posthog as any).__initialized
) {
    posthog.init(process.env.REACT_APP_POSTHOG_KEY ?? '', {
        api_host: (() => {
            const baseApiUrl: string = process.env.REACT_APP_API_URL ?? '';
            const i = baseApiUrl.lastIndexOf('/api');
            if (i !== -1) {
                return baseApiUrl.slice(0, i) + '/ph';
            }
        })(),
        ui_host: 'https://us.posthog.com',
        defaults: '2025-05-24',
        person_profiles: 'always',
        debug: false,
        capture_dead_clicks: true,
        capture_exceptions: true,
        capture_performance: true,
        enable_recording_console_log: true,
        session_recording: {
            recordBody: true,
            recordHeaders: true,
            maskAllInputs: false,
            maskCapturedNetworkRequestFn: request => request, // override posthog defaults - do not mask anything
        },
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (posthog as any).__initialized = true;
}

export { posthog, PostHogProvider };
